module.exports = __webpack_public_path__ + "img/logo.db3667fa.png";